import type FilterNamingService from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import createFilterNamingService from "./filter-naming-service/factory";

const filterNamingService: FilterNamingService = createFilterNamingService();

export default filterNamingService;
